import SelectedVisibleAreas from './selected-visible-areas'
export default SelectedVisibleAreas
